import { z } from "zod";

import { simpleDateSchema } from "@/src/models/common-schema";

export const DocumentDateSchema = z.object({
  dateOfDocument: simpleDateSchema
    .nullable()
    .describe("Date on the document usually found in a letter head. Format as YYYY-MM-DD."),
  dateReceived: simpleDateSchema
    .nullable()
    .describe(
      "Date the document was received. Look for content in the document like: 'Received', 'Received Date', 'Received on', ... Format as YYYY-MM-DD."
    ),
  dateSigned: simpleDateSchema
    .nullable()
    .describe(
      "Date the document was signed. Look for content in the document like: 'Signed', 'Signed Date', 'Signed on', ... Format as YYYY-MM-DD."
    ),
  dateOfEvent: simpleDateSchema
    .nullable()
    .describe(
      "Date of event is the date of exam/evaluation (including labels like 'Date of Evaluation' or 'Current Evaluation Date'), date collected/collection date (for labs, cologuard), date of service, date of appointment, date of visit, date of procedure, date of encounter, etc. Prefer the date tied to the actual encounter or evaluation over plan/document dates. It is NOT USUALLY date signed or date received (this is sometimes later, and is not the date of the actual event). Format as YYYY-MM-DD."
    ),
});
